// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__39S-M","title":"styles_title__31znm","br":"styles_br__1ibU2","contacts":"styles_contacts__2u7qF"};